// import React, { useState, useEffect } from 'react'
// import { Grid, Divider, Card, CardContent,Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button , Snackbar } from "@material-ui/core";
// import MuiAlert from '@material-ui/lab/Alert';
// import { useSelector, shallowEqual } from 'react-redux'
// import { GetCoachServices, DeleteCoachService } from '../api/index'
// import moment from 'moment';
// import { useHistory } from 'react-router-dom'

// function Alert(props) {
//     return <MuiAlert elevation={6} variant="filled" {...props} />;
// }

// const Services = () => {
//     const [list, setList] = useState([])
//     const { user } = useSelector(({ auth }) => auth, shallowEqual);
//     const [pending, setPending] = useState(false);

//     const [form, setForm] = useState(()=>({
//         isOpen: false,
//         _id: '',
//         pending: false
//     }))

//     const [snackbar, setSnackbar] = useState(()=>({
//         isOpen: false,
//         message: '',
//         type: 'success'
//     }))
//     const history = useHistory();
//     useEffect(()=>{
//         fetchServicesList();
//     }, [])
//     const fetchServicesList = async () => {
//         setPending(true);
//         let data = await GetCoachServices(user.id);
//         setList(data.data);
//         setPending(false);
//     }
//     const handleDelete = async () =>{
//         setForm((pre)=>({
//             ...pre,
//             pending: true
//         }))
//         try{
//             let res = await DeleteCoachService(form._id);
//             setSnackbar((pre)=>({
//                 isOpen: true,
//                 message: res.message,
//                 type: 'success'
//             }))
//             fetchServicesList();
//         }catch(error){
//             setSnackbar((pre)=>({
//                 isOpen: true,
//                 message: error.response ? error.response.message : error.message,
//                 type: 'error'
//             }))
//             console.log(error);
//         }finally{
//             setForm((pre)=>({
//                 ...pre,
//                 pending: false,
//                 isOpen: false
//             }))
//         }
//     }
//     return <>
//         <Snackbar open={snackbar.isOpen} autoHideDuration={6000} onClose={()=>{setSnackbar((pre)=>({...pre, isOpen: false}))}}>
//             <Alert onClose={()=>{setSnackbar((pre)=>({...pre, isOpen: false}))}} severity={snackbar.type}>
//                 { snackbar.message }
//             </Alert>
//         </Snackbar>
//         <div className='serviceTitle border border-danger'>
//             <h1>Services</h1>
//             {/* <button onClick={()=>{history.push('/services/add')}}>Add Service</button> */}
//         </div>
//         { pending ?
//         <div className="w-100 d-flex align-items-center justify-content-between mb-2 border border-primary" >
//             <div class="spinner-border text-danger mx-auto" role="status"></div>
//         </div>
//         :
//         list.length == 0 ? <h3 className='text-center'>No Services available</h3> :
//         <Grid container spacing={2} className="mt-5 border border-danger">
//             {list.map((service, i)=>{
//                 return <Grid item md={3} xs={12}>
//                 <Card style={{borderRadius: '16px'}}>
//                     <CardContent className='border border-danger'>
//                         <div className='servicesCardContainer border border-success'>
//                             <div className="heading border ">
//                                 <h1>{service.title}</h1>
//                                 <p>{moment(service.date).format('MM-DD-YYYY')}</p>
//                             </div>
//                             <div className="actionButton">
//                                 <button className='edit' onClick={()=>{history.push({
//                                     pathname: `/services/${service._id}`,
//                                     state: {service}
//                                 })}}>
//                                     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                     <path d="M8.69063 20.2499H4.5C4.30109 20.2499 4.11033 20.1709 3.96967 20.0302C3.82902 19.8896 3.75 19.6988 3.75 19.4999V15.3093C3.74966 15.2119 3.76853 15.1154 3.80553 15.0253C3.84253 14.9352 3.89694 14.8533 3.96563 14.7843L15.2156 3.53429C15.2854 3.46343 15.3686 3.40715 15.4603 3.36874C15.5521 3.33033 15.6505 3.31055 15.75 3.31055C15.8495 3.31055 15.9479 3.33033 16.0397 3.36874C16.1314 3.40715 16.2146 3.46343 16.2844 3.53429L20.4656 7.71554C20.5365 7.78533 20.5928 7.86851 20.6312 7.96026C20.6696 8.052 20.6894 8.15046 20.6894 8.24992C20.6894 8.34938 20.6696 8.44784 20.6312 8.53958C20.5928 8.63132 20.5365 8.71451 20.4656 8.78429L9.21563 20.0343C9.1466 20.103 9.06469 20.1574 8.9746 20.1944C8.88452 20.2314 8.78802 20.2503 8.69063 20.2499V20.2499Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                                     <path d="M12.75 6L18 11.25" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                                     </svg>
//                                 </button>
//                                 <button className='delete' onClick={()=>{setForm((pre)=>({...pre, isOpen: true, _id: service._id}))}}>
//                                     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                     <path d="M20.25 5.25H3.75" stroke="#FF4242" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                                     <path d="M9.75 9.75V15.75" stroke="#FF4242" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                                     <path d="M14.25 9.75V15.75" stroke="#FF4242" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                                     <path d="M18.75 5.25V19.5C18.75 19.6989 18.671 19.8897 18.5303 20.0303C18.3897 20.171 18.1989 20.25 18 20.25H6C5.80109 20.25 5.61032 20.171 5.46967 20.0303C5.32902 19.8897 5.25 19.6989 5.25 19.5V5.25" stroke="#FF4242" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                                     <path d="M15.75 5.25V3.75C15.75 3.35218 15.592 2.97064 15.3107 2.68934C15.0294 2.40804 14.6478 2.25 14.25 2.25H9.75C9.35218 2.25 8.97064 2.40804 8.68934 2.68934C8.40804 2.97064 8.25 3.35218 8.25 3.75V5.25" stroke="#FF4242" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//                                     </svg>
//                                 </button>
//                             </div>
//                         </div>
//                     </CardContent>
//                 </Card>
//             </Grid>
//             })}

//         </Grid>
//          }

//         <Dialog
//             open={form.isOpen}
//             onClose={()=>{setForm((pre)=>({...pre, isOpen: false}))}}
//             aria-labelledby="alert-dialog-title"
//             aria-describedby="alert-dialog-description"
//         >
//             <DialogTitle id="alert-dialog-title">{"Delete Service"}</DialogTitle>
//             <DialogContent>
//             <DialogContentText id="alert-dialog-description">
//                 Are you sure ?
//             </DialogContentText>
//             </DialogContent>
//             <DialogActions>
//             <Button onClick={()=>{setForm((pre)=>({...pre, isOpen: false}))}} color="primary">
//                 Cancel
//             </Button>
//             <Button onClick={()=>{
//                 handleDelete()
//             }} color="primary" autoFocus disabled={form.pending}>
//                 { form.pending ? <div style={{color: '#ff4242'}} class="spinner-border mx-auto" role="status"></div> : 'Sure' }
//             </Button>
//             </DialogActions>
//         </Dialog>
//     </>
// }

// export default Services

import React, { useEffect, useState } from "react";
import ServiceCard from "../../components/ServiceCard";
import { useSelector, shallowEqual } from "react-redux";
import {
  GetCoachServices,
  DeleteCoachService,
  GetServicesStats,
} from "../api/index";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { input, Menu, Modal, InputBase, makeStyles } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import AddServices from "./AddService";
import EditServices from "./EditService";
import MunuPOPup from "./MunuPOPup";
import Delete from "./Delete";
import ViewTable from "./ViewTable";
import SalesTable from "./TotalSaleTable";
import { CSVLink } from "react-csv";
import Swal from "sweetalert2";

const Services = () => {
  const [list, setList] = useState([]);
  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  const [pending, setPending] = useState(false);
  const [search, setSearch] = useState("");

  const [openAddService, setOpenAddService] = useState(false);
  const [openEditService, setOpenEditService] = useState(false);
  const [editService, setEditService] = useState({});
  const [openMunuPOP, setOpenMunuPOPup] = useState(false);
  const [openDelete, setOpenDelete1] = useState(false);
  const [openViewTable, setOpenViewTable] = useState(false);
  const [openSaleTable, setOpenSaleTable] = useState(false);

  const [selectedService, setSelectedService] = useState(null);
  const [stats, setStats] = useState({
    totalServices: 0,
    totalSales: 0,
    totalUser: 0,
  });
  const [pendingStats, setPendingStats] = useState(false);

  const fetchServicesList = async () => {
    setPending(true);
    let data = await GetCoachServices(user.id, search);
    setList(data.data);
    setPending(false);
  };

  const fetchStats = async () => {
    setPendingStats(true);
    const data = await GetServicesStats(user.id);
    setStats(data.data);
    setPendingStats(false);
  };

  // useEffect(()=>{
  //   fetchServicesList()
  // }, [])
  useEffect(() => {
    // console.log(list);
    fetchStats();
  }, []);
  useEffect(() => {
    fetchServicesList();
  }, [search]);

  const CSVHeaders = [
    { label: "category", key: "category" },
    { label: "title", key: "title" },
    { label: "subtitle", key: "subtitle" },
    { label: "price", key: "price" },
    { label: "time", key: "time" },
    { label: "description", key: "discription" },
  ];

  const useStyles = makeStyles((theme) => ({
    root: {
      position: "relative",
    },
    search: {
      position: "relative",
      marginLeft: "-252px",
      marginTop: "-7px",
      borderRadius: theme.shape.borderRadius,
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "auto",
      },
    },
    searchIcon: {
      padding: theme.spacing(2, 2),
      height: "100%",
      zIndex: "9",
      color: "#000000",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    inputRoot: {
      color: "inherit",
      fontSize: "14px",
    },
    inputInput: {
      padding: theme.spacing(1.5, 1.5, 1.5, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: "40px !important",
      // paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create("width"),
      width: "15rem !important",
      position: "absolute",
      color: "black"
      // [theme.breakpoints.up("md")]: {
      //   width: "40ch",
      // },
    },
  }));
  const classes = useStyles();

  return (
    <div className="">
      <div className="serviceTitle pb-5">
        <h1>Services</h1>
      </div>

      <div className="container m-0 p-0">
        <div className="row m-0 p-0">
          <div className="col-lg-3 col-md-6 col-sm-12 col-12 p-0">
            <ServiceCard
              para="Total User"
              heading={stats.totalUser}
              pending={pendingStats}
            />
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 col-12 p-0 px-2">
            <ServiceCard
              para="Total Services"
              heading={stats.totalServices}
              pending={pendingStats}
            />
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 col-12 p-0 px-2">
            <ServiceCard
              para="Total Sales"
              heading={`${stats.totalSales}$`}
              pending={pendingStats}
            />
          </div>
          <div className="col-lg-3 col-md-6 col-sm-12 col-12 p-0">
            <ServiceCard para="Text" heading="53" />
          </div>
        </div>
      </div>
      {/* <ViewTable/> */}

      <div className="rounded-lg overflow-hidden border mt-10">
        <div className="d-flex align-items-center">
          <form
            className="navbar-form navbar-left d-flex w-100 justify-content-between align-items-center px-3 py-5"
            style={{ background: "#ebf2f3", borderBottom: "3px solid #FFF" }}
          >
            <h1 className="pt-2">Service Details</h1>

            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center">
                {/* <input
                  type="search"
                  onChange={(e) => {
                    e.persist();
                    setSearch(e.target.value);
                  }}
                  value={search}
                  className="form-control py-5 "
                  placeholder="Search"
                /> */}
                <div className={classes.search}>
                  <div className={classes.searchIcon}>
                    <SearchIcon />
                  </div>
                  <InputBase
                    type="search"
                    value={search}
                    placeholder="Search"
                    classes={{
                      root: classes.inputRoot,
                      input: classes.inputInput,
                    }}
                    style={{ width: "15rem" }}
                    inputProps={{ "aria-label": "search" }}
                    onChange={(e) => {
                      e.persist();
                      setSearch(e.target.value);
                    }}
                  />
                </div>
              </div>
              <CSVLink
                headers={CSVHeaders}
                data={list}
                filename={`report_${new Date().getTime()}.csv`}
                className="px-5 py-4 rounded-sm border-0 btn_color text-white ml-3"
                onClick={() => {
                  if (pending) {
                    Swal.fire({
                      icon: "error",
                      title: "Error",
                      text: "Fetching Data",
                    });
                    return false;
                  }
                  if (list.length == 0) {
                    Swal.fire({
                      icon: "error",
                      title: "Error",
                      text: "No data available",
                    });
                    return false;
                  }
                }}
              >
                Export CSV
              </CSVLink>
              {/* <button
                type="submit"
                className=" px-5 py-2 rounded-sm border-0 btn_color text-white ml-3"
              >
                Export CSV
              </button> */}
              <button
                type="button"
                onClick={() => {
                  setOpenAddService(true);
                }}
                className="rounded-sm px-5 py-4 border-0  btn_color text-white ml-3"
              >
                Add New Service
              </button>
              <button
                type="button"
                onClick={() => {
                  setOpenSaleTable(true);
                }}
                className="rounded-sm px-5 py-4 border-0  btn_color text-white ml-3"
              >
                View Sale History
              </button>

              {/* <AddServices/> */}
            </div>
          </form>
        </div>

        <table class="table  m-0 p-0 ">
          <thead className="bg-light" style={{background: ""}}>
            <tr>
              <th className="py-5" style={{fontSize: "16px"}}>Category</th>
              <th style={{fontSize: "16px"}}>Title</th>
              <th style={{fontSize: "16px"}}>Subtitle</th>
              <th style={{fontSize: "16px"}}>Price</th>
              <th style={{fontSize: "16px"}}>Time</th>
              <th style={{fontSize: "16px"}}>Description</th>
              <th className="text-center" style={{fontSize: "16px"}}>Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {pending ? (
              <tr>
                <td colSpan={7}>
                  <div className="w-100 d-flex align-items-center justify-content-between py-2">
                    <div
                      class="spinner-border text-danger mx-auto"
                      role="status"
                    ></div>
                  </div>
                </td>
              </tr>
            ) : (
              list.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="align-middle">{item.category}</td>
                    <td className="align-middle">{item.title}</td>
                    <td className="align-middle td1">{item.subtitle}</td>
                    <td className="align-middle">${item.price}</td>
                    <td className="align-middle">{item.time}</td>
                    <td className="td2 text-truncate align-middle">{item.discription}</td>
                    <td className="d-flex justify-content-center align-middle cursor-pointer">
                      {/* <img
                        src="/assets/images/menu.svg"
                        alt=""
                        onClick={() => {
                          setOpenMunuPOPup(true);
                          setSelectedService(item);
                        }}
                        className="pt-3 position-relative hover"
                      /> */}
                      <MoreVertIcon onClick={() => {
                        setOpenMunuPOPup(true);
                        setSelectedService(item);
                      }} />
                    </td>
                  </tr>
                );
              })
            )}

            {!pending && list.length == 0 && (
              <tr>
                <td align="center" colSpan={7}>
                  No Service Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Modal
        open={openAddService}
        onClose={() => {
          setOpenAddService(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{ onClick: () => {} }}
      >
        <AddServices
          fetchServicesList={fetchServicesList}
          setOpenAddService={setOpenAddService}
        />
      </Modal>
      <Modal
        open={openEditService}
        onClose={() => {
          setOpenEditService(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{ onClick: () => {} }}
      >
        <EditServices
          fetchServicesList={fetchServicesList}
          setOpenEditService={setOpenEditService}
          selectedService={selectedService}
        />
      </Modal>

      <Modal
        open={openMunuPOP}
        onClose={() => {
          setOpenMunuPOPup(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        // BackdropProps={{ onClick: () => {} }}
      >
        <MunuPOPup
          setOpenEditService={setOpenEditService}
          setOpenMunuPOPup={setOpenMunuPOPup}
          setOpenDelete1={setOpenDelete1}
          setOpenViewTable={setOpenViewTable}
        />
      </Modal>
      {/* Delete Modal */}
      <Modal
        open={openDelete}
        onClose={() => {
          setOpenDelete1(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{ onClick: () => {} }}
      >
        <Delete
          setOpenDelete1={setOpenDelete1}
          fetchServicesList={fetchServicesList}
          selectedService={selectedService}
        />
      </Modal>

      {/* View Table */}
      <Modal
        open={openViewTable}
        onClose={() => {
          setOpenViewTable(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        // BackdropProps={{ onClick: () => {} }}
      >
        <ViewTable
          setOpenViewTable={setOpenViewTable}
          selectedService={selectedService}
        />
      </Modal>
      {/* Sales Table */}
      <Modal
        open={openSaleTable}
        onClose={() => {
          setOpenSaleTable(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        // BackdropProps={{ onClick: () => {} }}
      >
        <SalesTable id={user.id} />
      </Modal>
      {/* <EditServices/> */}
    </div>
  );
};

export default Services;
